module.exports = __webpack_public_path__ + "img/slash.75d128db.svg";